import React, { useEffect, useRef } from 'react';
import VideoSourceType from 'Shared/ViewModels/VideoSourceViewModel.type';
import Hls from "hls.js";
import VideoSource from './VideoSource';

type VideoType = {
  videoRef?: React.MutableRefObject<HTMLVideoElement>;
  autoPlay: boolean;
  loop: boolean;
  muted: boolean;
  isMobile: boolean;
  coverContent: boolean;
  playsInline: boolean;
  fixedVideo?: boolean;
  sources?: VideoSourceType[];
  onEnded?: () => void,
};

const VideoPlayer = (props: VideoType) => {
  const { sources, videoRef, autoPlay, loop, muted, isMobile, fixedVideo = false, coverContent, playsInline } = props;
  const playerRef = videoRef ? videoRef : useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if(playerRef && playerRef.current) {

      const video = playerRef.current;
      const hlsSource = sources?.find(x => x.type === 'HLS' && (x.device === 'ALL' || x.device === (isMobile ? 'MOBILE' : 'DESKTOP')));
      if (hlsSource && Hls.isSupported()) {
        var hls = new Hls();
        hls.loadSource(hlsSource.url);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, function() { 
          if(autoPlay) {
            video.play();
          }
        });
      } else if (hlsSource && video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = hlsSource.url;
      }

      if(!muted) {
        video.volume = 0.5;
      }
    }
  }, []);
  
  return (
    <video
      className="videoCanvas"
      ref={playerRef}
      autoPlay={autoPlay}
      loop={loop}
      muted={muted}
      playsInline={playsInline}
      onEnded={props.onEnded}
      style={{
        ...(coverContent && {
          width: '100%',
          ...(fixedVideo ? { zIndex: -1, height: 'auto', position: 'fixed', top: 0, left: 0 } : { height: '100%' }),
          objectFit: 'cover',
          objectPosition: 'center center',
        })
      }}
    >
      {sources?.filter(x => x.type !== "HLS").map((source, i) => {
          return (
            ((source.device === 'ALL' ||
              (source.device === 'DESKTOP' && !isMobile) ||
              (source.device === 'MOBILE' && isMobile)) && source.type !== 'HLS') && (
                <VideoSource key={i} type={source.type} url={source.url} />
            )
          );
        })} 
    </video>
  );
};

export default VideoPlayer;

